import 'core-js';
import '@babel/polyfill';
import 'picturefill';
import 'custom-event-polyfill';
import 'object-fit-polyfill';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/inViewport.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import singlePharmacy from './routes/single-pharmacy';
import singleProduct from './routes/single-product';
import pharmacySearch from './routes/pharmacy-search';
import landingpageServicefeatures from './routes/landingpage-servicefeatures';

/** Populate Router instance with DOM routes */

const routes = new Router({
  common,
  singlePharmacy,
  singleProduct,
  pharmacySearch,
  landingpageServicefeatures,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());




// WEBPACK FOOTER //
// ./scripts/main.js